module.exports = __webpack_public_path__ + "img/logo-color-inline.359bbe98.svg";